/**
 * @generated SignedSource<<11d2ce643e60d0bb65d6fcb9ce51b6da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Status = "ACTIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DigestJobInfo_job$data = {
  readonly id: any;
  readonly latestPromptFeedback: {
    readonly id: any;
    readonly suggestions: ReadonlyArray<{
      readonly isStale: boolean;
      readonly name: string;
    }>;
  } | null | undefined;
  readonly name: string;
  readonly nextRunAt: any | null | undefined;
  readonly schedule: any | null | undefined;
  readonly status: Status;
  readonly team: {
    readonly id: any;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "DigestJobInfo_job";
};
export type DigestJobInfo_job$key = {
  readonly " $data"?: DigestJobInfo_job$data;
  readonly " $fragmentSpreads": FragmentRefs<"DigestJobInfo_job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DigestJobInfo_job",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schedule",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextRunAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLTeam",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLPromptFeedback",
      "kind": "LinkedField",
      "name": "latestPromptFeedback",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLPromptSuggestion",
          "kind": "LinkedField",
          "name": "suggestions",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isStale",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLJob",
  "abstractKey": null
};
})();

(node as any).hash = "428bcc7fb98b4819d29adb0ad9a6c981";

export default node;
